import React from "react";
import { Table, Button } from "antd";
import { useLanguage } from "../../../../context/LanguageContext";
import dashboardContent from "../../../../utils/dashboardContent";

const LastReportTable = ({ reports }) => {
  const { language } = useLanguage();
  const text = dashboardContent[language].reports.analysis;

  const handleDownload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = fileName || "report.pdf"; // Standardname setzen
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Fehler beim Herunterladen der Datei:", error);
    }
  };

  const columns = [
    {
      title: text.table.name,
      dataIndex: "name",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: text.table.date,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
    {
      title: text.table.from,
      dataIndex: "from",
      key: "from",
      render: (period) =>
        period ? new Date(period).toLocaleDateString() : "-",
    },
    {
      title: text.table.to,
      dataIndex: "to",
      key: "to",
      render: (period) =>
        period ? new Date(period).toLocaleDateString() : "-",
    },
    {
      title: text.table.action,
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => handleDownload(record.fileUrl, record.name + ".pdf")}
        >
          {text.table.download}
        </Button>
      ),
    },
  ];

  const data = reports.map((report, index) => ({
    key: index,
    name: report.title,
    createdAt: report.createdAt,
    from: report.reportPeriod?.start,
    to: report.reportPeriod?.end,
    fileUrl: report.url,
  }));

  return (
    <div className="p-4 my-4">
      <h1
        className="text-2xl md:text-3xl font-bold text-center mb-6 mt-10 text-gray-800"
        id="reports"
      >
        {text.lastReportsTitle}
      </h1>
      <Table
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 5 }}
        className="overflow-x-scroll custom-scrollbar"
        locale={{
          emptyText: text.lastReportsEmpty,
        }}
      />
    </div>
  );
};

export default LastReportTable;
